export default function ContactWhyUs() {
  const reasons = [
    {
      icon: 'ri-user-heart-line',
      title: 'Two Real Humans Answer Every Message',
      body: "Rockhound Auto is a two-person operation — not a franchise, not a call center, not a chatbot farm. When you reach out, you're talking directly to the people who source, inspect, and sell every vehicle on our lot. There's no ticket queue, no tier-1 support script, and no one reading from a FAQ sheet. Just two people who genuinely care whether you end up in the right car.",
    },
    {
      icon: 'ri-time-line',
      title: 'We Respond Within 2 Hours',
      body: "Most dealerships take 24–48 hours to respond — if they respond at all. We've built our entire business on being the opposite of that. During business hours, expect a real reply within two hours. After hours, we'll have something in your inbox first thing in the morning. We know you're shopping multiple options, and we respect your time enough to actually show up.",
    },
    {
      icon: 'ri-shield-check-line',
      title: 'No Pressure. No Follow-Up Spam.',
      body: "Ask us a question and we'll answer it — honestly, completely, and without turning it into a sales pitch. We don't do aggressive follow-up calls. We don't add you to a drip campaign. We don't have a CRM that auto-dials you three times a day. You ask, we answer, and the next move is entirely yours. That's how we'd want to be treated, so that's how we treat you.",
    },
    {
      icon: 'ri-map-pin-2-line',
      title: 'Serving the Entire Pacific Northwest',
      body: "Our showroom is in Warrenton, Oregon — right on the northern Oregon coast — but we work with buyers from Astoria, Seaside, Tillamook, Portland, Longview, Kelso, Vancouver WA, and beyond. We handle remote purchases, out-of-state paperwork, and vehicle delivery across Oregon and Washington. Distance is not a barrier. If you're in the Pacific Northwest, we can help.",
    },
  ];

  return (
    <section className="py-16 bg-[#F7F5F0] border-t border-[#E8E2D6]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <span className="inline-block text-xs font-bold uppercase tracking-widest text-[#4A5568] mb-3">
            Why Reach Out to Us
          </span>
          <h2
            className="text-3xl sm:text-4xl font-black text-[#1A2332] mb-4"
            style={{ fontFamily: "'Oswald', sans-serif" }}
          >
            WHAT MAKES CONTACTING US DIFFERENT
          </h2>
          <p className="text-[#5A6A7A] text-base max-w-2xl mx-auto">
            We've heard every horror story about reaching out to a dealership. Here's our commitment to making sure yours doesn't become one.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {reasons.map((r) => (
            <article key={r.title} className="bg-white rounded-xl border border-[#E8E2D6] p-6 flex flex-col gap-4">
              <div className="w-11 h-11 flex items-center justify-center bg-[#FFFBF0] border border-[#F0E0A0] rounded-lg">
                <i className={`${r.icon} text-[#E8B84B] text-xl`}></i>
              </div>
              <h3
                className="text-base font-black text-[#1A2332] leading-snug"
                style={{ fontFamily: "'Oswald', sans-serif" }}
              >
                {r.title}
              </h3>
              <p className="text-sm text-[#374151] leading-relaxed">{r.body}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}